import {useEffect} from "react";
import {MAX_FETCH_DATA_SIZE, ResourceNames} from "../../config/const";
import {convertDataForSortableImage} from "../../common/image/databaseImageUtils";
import {CarColorSuspensionImageProps} from "./CarColorSuspensionImageComponent";

export const useCarColorSuspensionImageHooks = (props: CarColorSuspensionImageProps) => {

    useEffect(() => {
        const awaitFn = async () => {
            await getImages()
        };
        awaitFn().then();
    }, [props.carColorId])

    const getImages = async () => {
        if (props.carColorId) {
            const result = await convertDataForSortableImage(props.dataProvider,
                ResourceNames.CAR_COLOR_SUSPENSION_IMAGE_RESOURCE,
                {
                    pagination: {page: 1, perPage: MAX_FETCH_DATA_SIZE},
                    sort: {field: 'position', order: 'ASC'},
                    filter: {
                        carColorId: props.carColorId,
                    }
                }
            )
            props.setImages(result);
        }
    }

}
